import { getRecaptchaToken } from "@adaptis/flow-components";
import { Callbacks } from "react-google-invisible-recaptcha";
import _ from "../imports/lodash-imports";
import dayjs from "dayjs";
import { getFlowDataDirect, setFlowDataDirect, useFlowData } from "@adaptis/flow-components";
import Config from "../app-config";
import * as API from "../KnoseAPI/Actions/api";
import * as ACTIONS from "../KnoseAPI/Actions/actions";
import { getPetAge } from "../KnoseAPI/Lib/Utils";
import { convertKnose2MM, convertMM2Knose } from "./helper-functions";

export async function bindBatchApiWrapper(params: any) {
  let token = await getRecaptchaToken();
  params.captcha = token;
  let result: any = {};
  //// debugger;
  result = await API.knoseAPI(Config.action_bind_batch, params);
  return result;
  //debugger;
}

// ===== BIND BATCH

export async function issueBatchApiWrapper(params: {}) {
  //let token = await getRecaptchaToken();
  let result: any = {};
  result = await API.knoseAPI(Config.action_issue_batch, params);
  return result;
}

// ==== SuburbPostcode Search =================================================

// -- knose-quote-tool\quote-tool\src\Components\Details.js
export async function fetchSuburbPostcodeLookup(value: string) {
  // let token = await getRecaptchaToken();
  let result: any = {};
  if (value && value.length >= 3) {
    // if (token !== undefined) {
    let params = {
      // captcha: token,
      templateGuid: "4ea56c0f-8ada-4dc3-8abf-98aa75881cfd",
    };

    result = await API.middlemanAPI(
      "/category/region?postcode=" +
      value,
      params,
      "GET"
    );
    // }
  }
  return result;
}

// ================


export async function getSalesJourneyInfo(value: any) {
  let result: any = {};
  // let token = await getRecaptchaToken();
  // if (token !== undefined) {
  let params = {
    // captcha: token
  };

  if (value) {
    result = await API.middlemanAPI(
      "/sales-journey?salesjourneyid=" + value,
      params,
      "GET"
    );
  }
  // }
  return result;
}

export async function getCustomerInfo(salesjourneyid: any, customerid: any) {
  let result: any = {};
  // let token = await getRecaptchaToken();
  // if (token !== undefined) {
  let params = {
    // captcha: token
  };

  if (salesjourneyid && customerid) {
    result = await API.middlemanAPI(
      "/sales-journey?salesjourneyid=" + salesjourneyid + "&customerid=" + customerid,
      params,
      "GET"
    );
  }
  // }

  return result;
}

// ==== Breeds ================================================================

export async function loadBreedsList() {
  // let token = await getRecaptchaToken();
  let result: any = {};

  // if (token !== undefined) {
  let params = {
    // captcha: token,
    templateGuid: "4ea56c0f-8ada-4dc3-8abf-98aa75881cfd",
  };

  result = await API.middlemanAPI(Config.action_get_breeds, params, "GET");
  // }

  return result;
}

// ==== Get Quote =============================================================
function getPetInfo(petData: any) {
  let promoCode = getFlowDataDirect("promoCode");
  let transferId = getFlowDataDirect("transferId");
  // if (!promoCode && petData.customCover.promoCode) {
  //   promoCode = petData.customCover.promoCode;
  // }
  let cover = {
    annual_limit: 25000,
    benefit_percentage: 80,
    annual_excess: 200,
    consultation: true,
    extra_benefits: true
  }

  let pet: any = {
    pet_no: petData.pet_no,
    // pet_age: getPetAge(dayjs(petData.petDOB).format("DD/MM/YYYY")).pet_age, // 'a 2-year-old',
    pet_dob: dayjs(petData.petDOB).format("YYYY-MM-DD"), //'01/01/2019',
    pet_breed: petData.breed, // 'Berger Blanc Suisse',
    // pet_breed_group_code: "",
    pet_sex: _.capitalize(petData.petSex), // 'Male',
    pet_name: petData.name, // 'Fred',
    policy_start_date: dayjs(petData.startDate).format("YYYY-MM-DD"), // '21/10/2021',
    pet_type: _.capitalize(petData.petType), // 'Dog',
    // pet_cover: "yes", // vetConsultationFees,
    // pet_age_category: petData.petAgeCategory,
    cover
  };

  if (petData.pet_refs) {
    pet.pet_refs = petData.pet_refs;
    if (transferId) {
      pet.pet_refs.transferId = transferId + "";
    }
  }

  if (petData.coverType === "custom") {
    let pet_percent = _.toNumber(petData.customCover.benefitPercentage);
    let pet_annual_limit = _.toNumber(petData.customCover.annualBenefitLimit);
    let pet_annual_excess = _.toNumber(petData.customCover.annualExcess);
    let pet_extra_cover = petData.customCover.optionalExtras;
    let pet_consultation = petData.customCover.vetConsultationFees;
    let pet_frequency = petData.customCover.paymentFrequency;
    if (petData.customCover.promoCode) {
      promoCode = petData.customCover.promoCode;
    }
    cover = {
      annual_limit: pet_annual_limit,
      benefit_percentage: pet_percent,
      annual_excess: pet_annual_excess,
      consultation: pet_consultation === 'yes' ? true : false,
      extra_benefits: pet_extra_cover === 'yes' ? true : false
    }


  } else if (petData.coverType === "top") {
    cover = {
      annual_limit: 25000,
      benefit_percentage: 90,
      annual_excess: 0,
      consultation: true,
      extra_benefits: true
    }
  }

  let annual_limit = cover.annual_limit;
  // console.log("PPP-161 getPetInfo", petData.petAgeCategory, annual_limit);
  switch (petData.petAgeCategory) {
    case 1:
    case 2:
      cover.annual_limit = annual_limit + (annual_limit * 0.2);
      break;
    case 3:
    case 4:
      cover.annual_limit = annual_limit + (annual_limit * 0.1);
      break;
  }

  if (promoCode) {
    _.set(pet, "promo_code", promoCode);
  }
  _.set(pet, "cover", cover);
  return pet;
}

export function getOwnerInfo() {
  //const holderFirstName = 'holderFirstName';
  const holderFirstName = getFlowDataDirect("holderFirstName");
  const email = getFlowDataDirect("holderEmail");
  const postcode = getFlowDataDirect("holderAddress.postcode");
  const state = getFlowDataDirect("holderAddress.state");
  const suburb = getFlowDataDirect("holderAddress.suburb");
  const holderLastName = getFlowDataDirect("holderLastName");
  const address1 = getFlowDataDirect("holderAddress.line1");
  const address2 = getFlowDataDirect("holderAddress.line2");
  const phone = getFlowDataDirect("holderPhone");
  const holderDOB = getFlowDataDirect("holderDOB");

  let owner: any = {
    // customerId: "",
    email: email,
    // owner_phone: phone,
    postcode: postcode,
    states: state,
    suburb: suburb,
    // first_name: holderFirstName,
    // last_name: holderLastName,
    // address_line_1: address1,
    // address_line_2: address2,
    // mobile_phone: phone,
    // date_of_birth: holderDOB,
  };

  let address = `${address1 ? address1 : ""}${address2 ? (", " + address2) : ""}`;
  address = address.trim();
  if (holderFirstName) {
    owner.first_name = holderFirstName
  }
  if (holderLastName) {
    owner.last_name = holderLastName
  }
  if (phone) {
    owner.mobile = phone
  }
  if (address) {
    owner.address = address
  }

  return owner;
}

export function getKlaviyoData() {
  const petsySessionId = getFlowDataDirect("sessionId");
  // console.log('PPP-155-petsySessionId', petsySessionId);
  return {
    leadSource: 'CostcoQT',
    leadSourceId: petsySessionId
  }
}

// export async function getQuote(petId: string, petIndex: number) {
export async function getQuote(allPets: any[], step: string = '') {
  let currentSessionId = getFlowDataDirect("mmSessionId");
  let refs = getFlowDataDirect("refs");
  const owner = getOwnerInfo();
  let pets: any[] = [];
  //Kiểm tra array (Fix sentry error)
  if (!Array.isArray(allPets)) {
    console.warn('allPets is not array:', allPets);
    allPets = [];
  }
  allPets.forEach((petData: any) => {
    let pet = getPetInfo(petData);
    if (pet.pet_breed) {
      pets.push(pet);
    }
  });

  let result: any;
  // let token = await getRecaptchaToken();
  // if (token !== undefined) {
    let params;
    // console.log("refs", refs);
    params = convertKnose2MM(pets, owner, refs ?? {});
    // (params as any).captcha = token;

    if (currentSessionId) {
      params.sessionId = currentSessionId.toString();
    }

    if (!params.refs) {
      params.refs = {};
    }

    params.refs = {
      ...params.refs,
      ...getKlaviyoData()
    }
    // console.log("PPP-161 getQuote", params);
    let endponint = "/quote/init";
    switch (step) {
      case 'purchase':
        endponint = "/purchase";
        break;
      case 'bindding':
        endponint = "/quote/pre-binding";
        break;
      default:
        if (currentSessionId) {
          endponint = "/quote/pricing";
        }
        break;
    }

    result = await API.middlemanAPI(
      endponint,
      params,
    );
    // console.log("result MM", result);
    // result = convertMM2Knose(result);
    if (result.data && result.data.quote) {
      setFlowDataDirect("mmSessionId", result.data.quote.sessionId);
    }
  // }
  return result;
}

export async function sendEmail(sessionId: string) {
  // let token = await getRecaptchaToken();
  let params = {
    // captcha: token,
    sessionId
  }
  let result = await API.middlemanAPI(
    "/quote/email",
    params,
  );
  return result;
}

export async function createPolicy(sessionId: string, paymentType: string, paymentDetails: any) {
  // console.log("handleProcessPayment 3", paymentDetails);
  // let token = await getRecaptchaToken();
  let params = {
    // captcha: token,
    sessionId,
    payment_type: paymentType,
    ...paymentDetails,
    // refs: { ...getKlaviyoData() }
  }
  let result = await API.middlemanAPI(
    "/purchase",
    params,
  );
  return result;
}

export async function validationPromo(code: string) {
  // let token = await getRecaptchaToken();
  let params = {
    // captcha: token,
    'promo_code': code,
    'brand': 'PETSY'
  }
  let result = await API.middlemanAPI(
    "/promo-code/validate",
    params,
  );
  return result;
}